import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { HealthCheckService } from './services/health-check.service';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LayoutComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'dx-tract-app';

  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly healthService = inject(HealthCheckService);

  ngOnInit(): void {
    // Initialize authentication check
    this.authService.getAuthenticationResult().subscribe({
      next: (result) => {
        console.log('Initial auth check:', result.isAuthenticated);

        // If authenticated, start health monitoring
        if (result.isAuthenticated) {
          this.initializeHealthMonitoring();
        }
      },
      error: (error) => {
        console.error('Auth initialization error:', error);
      },
    });
  }

  private initializeHealthMonitoring(): void {
    // Perform initial health check
    this.healthService.checkHealth().subscribe({
      next: (health) => {
        console.log('System health status:', health.status);
      },
      error: (error) => {
        console.warn('Health check failed:', error);
      },
    });
  }

  isAuthRoute(): boolean {
    const currentUrl = this.router.url;
    return currentUrl.startsWith('/auth/') || currentUrl.startsWith('/login') || currentUrl.startsWith('/register');
  }
}
